import { isNud } from '@/shared/utilities/typing'
import SchoolClass from '@/shared/models/entities/school-class';
import PlannedWorksheet from '@/shared/models/entities/repocraft/planned-worksheet';
import StudentWorksheet from '@/shared/models/entities/repocraft/student-worksheet';

/**
 * 実施ふり返りシート配布 エンティティ
 */
class Handout {
    handout_id;
    planned_worksheet;
    school_class;
    handout_datetime;
    deadline_datetime;
    student_worksheets;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.handout_id = properties.handout_id;

        this.planned_worksheet = new PlannedWorksheet(properties.planned_worksheet);
        this.school_class = new SchoolClass(properties.school_class);
        this.handout_datetime = properties.handout_datetime;
        this.deadline_datetime = properties.deadline_datetime;

        this.student_worksheets = [];
        if ('student_worksheets' in properties) {
            for (let student_worksheet of properties.student_worksheets) {
                this.student_worksheets.push(new StudentWorksheet(student_worksheet));
            }
        }
    }
}

export default Handout;
